import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app/app.js";
import { ErrorBoundary } from "./app/error-boundary.js";
import { AppProviders } from "./app/providers.js";
import { parseEnvironment } from "./config/environment.js";
import { silentTelemetry } from "./shared/telemetry/telemetry.js";
import "./styles/global.css";

const root = document.querySelector<HTMLDivElement>("#root");
if (root === null) throw new Error("TradingApp root element is missing.");
const environment = parseEnvironment(import.meta.env);

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary telemetry={silentTelemetry}>
      <AppProviders environment={environment}>
        <App />
      </AppProviders>
    </ErrorBoundary>
  </StrictMode>,
);
